
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perguntas-frequentes/[slug]",
      function () {
        return require("private-next-pages/perguntas-frequentes/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perguntas-frequentes/[slug]"])
      });
    }
  